import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import DocumentSubmissionForm from './components/document-submission-form/document-submission-form';
import ReportsService from '../../../../../services/reports-service';

const ReportSubmission = () => {
    // console.log('doc sub opened');

    const reportsService = new ReportsService();
    const { applicationId, bpId, interestPaymentDate, reportHash } = useParams();
    const [applicationData, setApplicationData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (applicationId) {
            reportsService.retrieveTaxExemptDocumentSubmissionEntry(applicationId, bpId, interestPaymentDate, reportHash)
                .then(response => {
                    setApplicationData(response);
                    // console.log("Retrieve response:", response);
                })
                .catch(error => {
                    setError(error);
                    console.error("Retrieve error:", error);
                })
                .finally(() => setLoading(false));
        } else {
            // console.log("ApplicationId or bpId is missing, skipping API call.");
            setLoading(false);
        }
    }, [applicationId, bpId]);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error fetching data: {error.message}</p>;
    // console.log(applicationData);

    return <DocumentSubmissionForm applicationData={applicationData} />;
};

export default ReportSubmission;
